import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '@progress/kendo-data-query/dist/npm/state';
import { LocationService } from 'src/app/admin/location/shared/services/location.service';
import { LocationSelectorInfo } from 'src/app/admin/user/shared/models/locationSelectorModel';
import { getCenralLobySelectedLocationIds } from 'src/app/lobby/lobby-central-views/state';
import { LocationMultiSelectorModel } from '../../models/location-multi-selector.model';
import { LocationMultiSelector } from '../../models/location-selector/location-multi-selector-model';
import { LocationDropDownModel } from '../../models/locations-drop-down-list.model';

@Component({
  selector: 'app-location-multi-selector',
  templateUrl: './location-multi-selector.component.html',
  styleUrls: ['./location-multi-selector.component.scss']
})
export class LocationMultiSelectorComponent implements OnInit {

  public checkedLocationIds: number[] = [-1];
  public userLocationIds: number[] = [-1];
  public expandedKeys: any[] = [];
  public selectorOpened: boolean = false;
  @Input() selectedLocationName: string = "Select";
  @Input() selectedLocationId: number = 0;
  @Input() labelText: string = '';
  @Input() isIncludeFloatLocation: boolean = true;
  @Input() hideBranchLess: boolean = false;
  @Input() includeInactive: boolean = false;
  @Input() isLobby: boolean = false;
  @Input() isDisableParentClick: boolean = false;
  @Input() dispatchStateEvent: boolean = true;
  @Input() isCenralLobbyLocationSelector: boolean = true;
  @Output() onChange: EventEmitter<LocationMultiSelectorModel[]> = new EventEmitter();


  @Input() page: string = "";
  @Input()
  public checkedKeys: any[] = [];
  @Input() selectorDisabled: boolean = false;

  @Output() onLocationsData = new EventEmitter<LocationMultiSelector>();
  selectedLocations: LocationMultiSelectorModel[] = [];
  public locationHierachy: LocationMultiSelector = {
    locations: [],
    locationsFlatData: []
  };

  constructor(private locationService: LocationService,
    private elementRef: ElementRef,
    private store: Store<State>,
    private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.locationService.getSelectorLocationHierachy(
      this.isDisableParentClick,
      this.isIncludeFloatLocation,
      this.hideBranchLess,
      this.includeInactive,this.isLobby).subscribe({
        next: (locationsHierachy) => {       

          this.locationHierachy = locationsHierachy as LocationMultiSelector;

          const branchArray = this.locationHierachy.locationsFlatData.filter(l => l.locationTypeId == 5);
          if (branchArray.length <= 1) {
            this.locationHierachy.locationsFlatData = branchArray;
          } else {
            this.locationHierachy.locationsFlatData;
          }

          this.onLocationsData.emit(this.locationHierachy);

          this.addExpandListItem(locationsHierachy.locations);

          if (this.isCenralLobbyLocationSelector) {
            this.store.select(getCenralLobySelectedLocationIds).subscribe((locationIds) => {            
              this.checkedKeys = locationIds;
            });
          }

          this.setOneBranchOnlyValue(branchArray, this.checkedKeys, this.locationHierachy, this.isCenralLobbyLocationSelector)

          this.setDefaultValue(this.checkedKeys, this.locationHierachy.locations);
        },
        error: (err) => {
          console.error(err);
        }
      });
  }

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      // clicked outside => close dropdown list
      this.selectorOpened = false;
    }
  }

  public closeDropDown() {
    this.selectorOpened = false;

  }

  public onItemSelected(data: LocationSelectorInfo) {
    this.selectorOpened = false;
  }

  public setOneBranchOnlyValue(branchArray: any[],
    checkedKeys: number[],
    locationHierachy: LocationMultiSelector,
    isCenralLobbyLocationSelector: boolean) {
    if (branchArray.length <= 1) {
      if (isCenralLobbyLocationSelector) {
        checkedKeys = checkedKeys.filter(key => locationHierachy.locationsFlatData.some(location => location.locationId === key));
      } else {
        checkedKeys = locationHierachy.locationsFlatData.map(location => location.locationId);
      }
      this.checkedKeys = checkedKeys;
    }
  }

  public setDefaultValue(checkedKeys: number[], items?: LocationMultiSelectorModel[]) {
    if (!items) return;

    for (const item of items) {
      if (checkedKeys.includes(item.locationId)) {
        if (item.isSelectable) {
          this.selectedLocations.push(item);
          this.setDefaultValue(checkedKeys, item.items)
        }
      }
      else {
        this.setDefaultValue(checkedKeys, item.items)
      }
    }
  }

  public handleChildCheck(childItems?: LocationMultiSelectorModel[]) {
    if (!childItems) return;

    for (const childItem of childItems) {
      if (childItem.isSelectable) {
        this.selectedLocations.push(childItem);
        this.handleChildCheck(childItem.items);
      }

    }
  }

  private addExpandListItem(treeItem: LocationDropDownModel[]) {
    treeItem.forEach(item => {
      if (item.items && item.items.length > 0) {
        this.expandedKeys.push(item.locationId);
        this.addExpandListItem(item.items)
      }
    });
  }

  public handleChange(data: any) {
    this.checkedKeys = data;
    const locationsFlatArray = this.locationHierachy.locationsFlatData;
    const selectedLocatonsArray = locationsFlatArray.filter(item => data.includes(item.locationId));
    this.selectedLocations = selectedLocatonsArray;
    this.onChange.emit(this.selectedLocations);
  }

  public locationClick() {
    this.selectorOpened = !this.selectorOpened;
  }

  public chips = [
    {
      label: "Apple",
      selected: false,
      removable: true,
      removeIcon: "k-icon k-i-delete",
    },
    {
      label: "Strawberry",
      selected: false,
      removable: true,
      removeIcon: "k-icon k-i-cancel-circle",
    },
    {
      label: "Banana",
      selected: false,
      removable: true,
      removeIcon: "k-icon k-i-close-outline",
    },
    {
      label: "Kiwi",
      selected: false,
      removable: true,
      removeIcon: "k-icon k-i-close",
    },
  ];

  public onRemove(item: LocationDropDownModel): void {
    const index = this.selectedLocations.findIndex((c) => c.locationId === item.locationId);
    const checkedKeyIndex = this.checkedKeys.findIndex(k => k == item.locationId);
    this.checkedKeys.splice(checkedKeyIndex, 1);
    this.selectedLocations.splice(index, 1);
    this.RemoveChildLocation(item.locationId);
    this.onChange.emit(this.selectedLocations);
  }

  public RemoveChildLocation(parentLocationId: number) {
    const location = this.locationHierachy.locationsFlatData.find(l => l.locationId == parentLocationId);
    if (location?.hasChild && (location.items?.length || 0) > 0) {
      location.items?.forEach(childLocation => {
        const index = this.selectedLocations.findIndex((c) => c.locationId === childLocation.locationId);
        const checkedKeyIndex = this.checkedKeys.findIndex(k => k == childLocation.locationId);
        this.checkedKeys.splice(checkedKeyIndex, 1);
        this.selectedLocations.splice(index, 1);
        this.RemoveChildLocation(childLocation.locationId);
      }
      )
    }
  }

}
